module.exports = __webpack_public_path__ + "static/media/Menu Icon.daac71cb.svg";